import { createAction } from '@reduxjs/toolkit';

export const resetAllSlices = createAction('mainStore/resetAllSlices');
